export const PUBLIC_CONTENT_PAGE_MAX_WIDTH = '1200px';
